/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreatePlanCommand } from '../../models/create-plan-command';
import { CreatePlanCommandResult } from '../../models/create-plan-command-result';

export interface ApiPlanCreatePlanPost$Params {
  
    /**
     * Plan creation command
     */
    body?: CreatePlanCommand
}

export function apiPlanCreatePlanPost(http: HttpClient, rootUrl: string, params?: ApiPlanCreatePlanPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreatePlanCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiPlanCreatePlanPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreatePlanCommandResult>;
    })
  );
}

apiPlanCreatePlanPost.PATH = '/api/Plan/CreatePlan';
